import * as am4charts from "@amcharts/amcharts4/charts";
import * as am4core from "@amcharts/amcharts4/core";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { useEffect } from "react";
import { observer } from "mobx-react";
import AnalyticsStore from "../../store/AnalyticsStore";
import moment from "moment";

const AreaChart = () => {
  let data = [];
  const colors5 = {
    equity: "#0469DC",
    balanced: "#59C3C3",
    alternative: "#F45B69",
    fi: "#F0B642",
    cash: "#4a4238",
  };

  const colors = {
    equity: "#03002F",
    balanced: "#810B7D",
    alternative: "#DB2255",
    fi: "#FE7B2C",
    cash: "#EEAD2D",

    // equity: "#ade8f4",
    // balanced: "#ffc2d1",
    // alternative: "#c77dff",
    // fi: '#ffdd00',
    // cash: "#b7e4c7"
    ...colors5,
  };

  useEffect(() => {
    let prevDate = "";
    AnalyticsStore.overall.familyAssetAllocationOverTime.map((item) => {
      let obj = {};
      if (prevDate === "") {
        prevDate = item.date;
      }
      obj.date = moment(item.date).toISOString();
      obj.displayDate = moment(item.date, "YYYY-MM-DD").format("DD MMM YYYY");
      obj.alternative =
        item.assetAllocations[2].assetAllocation.allocation_percentage;
      obj.balanced =
        item.assetAllocations[4].assetAllocation.allocation_percentage;
      obj.equity =
        item.assetAllocations[0].assetAllocation.allocation_percentage;
      obj.cash = item.assetAllocations[3].assetAllocation.allocation_percentage;
      obj.fixedIncome =
        item.assetAllocations[1].assetAllocation.allocation_percentage;
      obj.equityValue =
        item.assetAllocations[0].assetAllocation.currentValue.value;
      obj.equityCurrency =
        item.assetAllocations[0].assetAllocation.currentValue.value_type;
      obj.alternativeValue =
        item.assetAllocations[2].assetAllocation.currentValue.value;
      obj.alternativeCurrency =
        item.assetAllocations[2].assetAllocation.currentValue.value_type;
      obj.cashValue =
        item.assetAllocations[3].assetAllocation.currentValue.value;
      obj.cashCurrency =
        item.assetAllocations[3].assetAllocation.currentValue.value_type;
      obj.balancedValue =
        item.assetAllocations[4].assetAllocation.currentValue.value;
      obj.balancedCurrency =
        item.assetAllocations[4].assetAllocation.currentValue.value_type;
      obj.fixedIncomeValue =
        item.assetAllocations[1].assetAllocation.currentValue.value;
      obj.fixedIncomeCurrency =
        item.assetAllocations[1].assetAllocation.currentValue.value_type;

      data.push(obj);
      return false;
    });

    am4core.useTheme(am4themes_animated);

    var chart = am4core.create("assetAllocationChart", am4charts.XYChart);
    chart.colors.step = 2;
    chart.logo.disabled = true;
    chart.leftAxesContainer.width = 0;
    chart.data = data;
    chart.chartContainer.wheelable = false;
    chart.chartContainer.draggable = false;
    chart.chartContainer.resizable = false;
    chart.maxZoomLevel = 1;
    chart.chartContainer.events.disableType("doublehit");
    chart.chartContainer.background.events.disableType("doublehit");
    chart.zoomOutButton.disabled = true;

    var dateAxis = chart.xAxes.push(new am4charts.DateAxis());
    dateAxis.renderer.minGridDistance = 0;
    dateAxis.renderer.grid.template.location = 0;
    dateAxis.renderer.grid.template.strokeWidth = 0;
    dateAxis.renderer.labels.template.textAlign = "center";
    dateAxis.renderer.labels.template.wrap = true;
    dateAxis.tooltip.disabled = true;
    dateAxis.startLocation = 0.5;
    dateAxis.endLocation = 0.5;
    dateAxis.baseInterval = {
      timeUnit: "month",
      count: 1,
    };

    dateAxis.gridIntervals.setAll([{ timeUnit: "month", count: 3 }]);

    dateAxis.dateFormats.setKey(
      "month",
      "[#7E8899 fontWeight: 400 fontSize: 80px]MMM YY[//]"
    );
    dateAxis.periodChangeDateFormats.setKey(
      "month",
      "[#7E8899 fontWeight: 400 fontSize: 10px]MMM YY[//]"
    );

    var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    valueAxis.visible = false;
    valueAxis.title.text = "Percent";
    valueAxis.calculateTotals = true;
    valueAxis.min = 0;
    valueAxis.max = 100;
    valueAxis.strictMinMax = true;
    valueAxis.renderer.grid.template.disabled = true;
    valueAxis.tooltip.disabled = true;
    valueAxis.renderer.labels.template.adapter.add("text", function (text) {
      return text + "%";
    });

    // Create series
    var series5 = chart.series.push(new am4charts.LineSeries());
    series5.dataFields.valueYShow = "totalPercent";
    series5.dataFields.valueY = "cash";
    series5.dataFields.dateX = "date";
    series5.name = "cash";
    series5.tooltipText = "{name}: [bold]{valueY}[/]";
    series5.tooltip.getFillFromObject = false;
    series5.tooltip.background.fill = am4core.color("#FFF");

    series5.tooltip.getStrokeFromObject = true;
    series5.tooltip.background.strokeWidth = 0;
    series5.tooltip.strokeWidth = 30;

    series5.fillOpacity = 1;
    series5.stacked = true;
    series5.fill = colors.cash;
    series5.strokeWidth = 0;

    // static
    series5.legendSettings.labelText = "Cash";

    // hovering
    series5.legendSettings.itemLabelText = "Cash";

    var series4 = chart.series.push(new am4charts.LineSeries());
    series4.dataFields.valueYShow = "totalPercent";
    series4.dataFields.valueY = "fixedIncome";
    series4.dataFields.dateX = "date";
    series4.name = "fixedIncome";
    series4.tooltipText = "{name}: [bold]{valueY}[/]";
    series4.tooltip.getFillFromObject = false;
    series4.tooltip.background.fill = am4core.color("#FFF");

    series4.tooltip.getStrokeFromObject = true;
    series4.tooltip.background.strokeWidth = 0;

    series4.fillOpacity = 1;
    series4.stacked = true;
    series4.fill = colors.fi;

    // static
    series4.legendSettings.labelText = "Fixed Income";

    // hovering
    series4.legendSettings.itemLabelText = "Fixed Income";
    series4.strokeWidth = 0;

    var series = chart.series.push(new am4charts.LineSeries());
    series.dataFields.valueY = "alternative";
    series.dataFields.valueYShow = "totalPercent";
    series.dataFields.dateX = "date";
    series.name = "alternative";
    series.tooltip.getFillFromObject = false;
    series.tooltip.background.fill = am4core.color("#FFF");
    series.tooltip.getStrokeFromObject = true;
    series.tooltip.background.strokeWidth = 0;
    series.fillOpacity = 1;
    series.stacked = true;
    series.fill = colors.alternative;

    // hovering
    series.legendSettings.itemLabelText = "Alternative";
    series.strokeWidth = 0;

    var series2 = chart.series.push(new am4charts.LineSeries());
    series2.dataFields.valueY = "balanced";
    series2.dataFields.valueYShow = "totalPercent";
    series2.dataFields.dateX = "date";
    series2.name = "balanced";
    series2.tooltip.getFillFromObject = false;
    series2.tooltip.background.fill = am4core.color("#FFF");

    series2.tooltip.getStrokeFromObject = true;
    series2.tooltip.background.strokeWidth = 0;

    series2.fillOpacity = 1;
    series2.stacked = true;
    series2.fill = colors.balanced;

    // static
    series2.legendSettings.labelText = "Hybrid/Multi Asset";
    series2.legendSettings.yAxes = "20px";

    // hovering
    series2.legendSettings.itemLabelText = "Hybrid/Multi Asset";
    series2.strokeWidth = 0;

    var series3 = chart.series.push(new am4charts.LineSeries());
    series3.dataFields.valueY = "equity";
    series3.dataFields.valueYShow = "totalPercent";
    series3.dataFields.dateX = "date";
    series3.name = "equity";
    series3.tooltip.getFillFromObject = false;
    series3.tooltip.background.fill = am4core.color("#FFF");

    series3.tooltip.getStrokeFromObject = true;
    series3.tooltip.background.strokeWidth = 0;

    series3.fillOpacity = 1;
    series3.stacked = true;
    series3.fill = colors.equity;

    // static
    series3.legendSettings.labelText = "Equity";

    // hovering
    series3.legendSettings.itemLabelText = "Equity";
    series3.strokeWidth = 0;

    let tooltipHtml = `<div style="width:155px">
    <p class="assetAllocationPopupDate"><strong style="">{displayDate}</strong></p>
    <div style="margin-top: 10px;display:flex;align-items:center">
      <div style="min-height: 15px; max-height: 15px; width: 15px; background: #0469DC;border-radius: 5px"></div>
        <div style="width:5px;height:15px;"></div>
        <div style="display:flex;width:calc(100% - 28px);justify-content:space-between;">
        <div style="color: #0469DC;font-family:"Roboto";font-weight: 500;margin-left: 20%"><b>{equity}%</b></div>
        <div style="font-weight: normal"><strong><b>{equityValue} {equityCurrency}</b></strong></div>
      </div>
    </div>
    <div style="margin-top: 10px;display:flex;align-items:center">
      <div style="min-height: 15px; max-height: 15px; width: 15px; background: #59C3C3;border-radius: 5px"></div>
        <div style="width:5px;height:15px;"></div>
        <div style="display:flex;width:calc(100% - 28px);justify-content:space-between;">
        <div style="color: #59C3C3;font-family:"Roboto";font-weight: 500;margin-left: 20%;"><b>{balanced}%</b></div>
        <div style="font-weight: normal"><strong><b>{balancedValue} {balancedCurrency}</b></strong></div>
      </div>
    </div>
    <div style="margin-top: 10px;display:flex;align-items:center">
      <div style="min-height: 15px; max-height: 15px; width: 15px; background: #F45B69;border-radius: 5px"></div>
        <div style="width:5px;height:15px;"></div>
        <div style="display:flex;width:calc(100% - 28px);justify-content:space-between;">
        <div style="color: #F45B69;font-family:"Roboto";font-weight: 500;margin-left: 20%;"><b>{alternative}%</b></div>
        <div style="font-weight: normal"><strong><b>{alternativeValue} {alternativeCurrency}</b></strong></div>
      </div>
    </div>
    <div style="margin-top: 10px;display:flex;align-items:center">
      <div style="min-height: 15px; max-height: 15px; width: 15px; background: #F0B642;border-radius: 5px"></div>
        <div style="width:5px;height:15px;"></div>
        <div style="display:flex;width:calc(100% - 28px);justify-content:space-between;">
        <div style="color: #F0B642;font-family:"Roboto";font-weight: 500;margin-left: 20%;"><b>{fixedIncome}%</b></div>
        <div style="font-weight: normal"><strong><b>{fixedIncomeValue} {fixedIncomeCurrency}</b></strong></div>
      </div>
    </div>
    <div style="margin-top: 10px;display:flex;align-items:center">
      <div style="min-height: 15px; max-height: 15px; width: 15px; background: #4a4238;border-radius: 5px"></div>
        <div style="width:5px;height:15px;"></div>
        <div style="display:flex;width:calc(100% - 28px);justify-content:space-between;">
        <div style="color: #4a4238;font-family:"Roboto";font-weight: 500;margin-left: 20%;"><b>{cash}%</b></div>
        <div style="font-weight: normal"><strong><b>{cashValue} {cashCurrency}</b></strong></div>
      </div>
    </div>
    </div>`;

    series.tooltipHTML = tooltipHtml;
    series2.tooltipHTML = tooltipHtml;
    series3.tooltipHTML = tooltipHtml;
    series4.tooltipHTML = tooltipHtml;
    series5.tooltipHTML = tooltipHtml;

    // Add cursor
    chart.cursor = new am4charts.XYCursor();
    chart.cursor.maxTooltipDistance = -1;
    chart.cursor.lineX.visible = false;
    chart.cursor.lineY.visible = false;
    chart.cursor.behavior = "none";

    // add legend
    chart.legend = new am4charts.Legend();
    chart.legend.position = "top";
    chart.legend.contentAlign = "left";
    chart.legend.visible = false;
    // eslint-disable-next-line
  }, []);
  return (
    <>
      {data ? (
        <div
          id="assetAllocationChart"
          style={{
            width: "102%",
            height: "450px",
            padding: "0px",
            marginTop: "-2%",
          }}
        ></div>
      ) : (
        "Loading.."
      )}
    </>
  );
};

export default observer(AreaChart);
